import { render, staticRenderFns } from "./LOVField.vue?vue&type=template&id=10466388&"
import script from "./LOVField.vue?vue&type=script&lang=js&"
export * from "./LOVField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports